// imported modules will register themselves automatically with prebid
import "prebid.js/modules/appnexusBidAdapter.js";
import "prebid.js/modules/criteoBidAdapter.js";
import "prebid.js/modules/gumgumBidAdapter.js";
import "prebid.js/modules/improvedigitalBidAdapter.js";
import "prebid.js/modules/ixBidAdapter.js";
import "prebid.js/modules/minutemediaBidAdapter.js";
import "prebid.js/modules/msftBidAdapter.js";
import "prebid.js/modules/ozoneBidAdapter.js";
import "prebid.js/modules/richaudienceBidAdapter.js";
import "prebid.js/modules/taboolaBidAdapter.js";

import "prebid.js/modules/atsAnalyticsAdapter.js";
import "prebid.js/modules/consentManagementTcf.js";
import "prebid.js/modules/consentManagementUsp.js";
import "prebid.js/modules/criteoIdSystem.js";
import "prebid.js/modules/currency.js";
import "prebid.js/modules/hadronIdSystem.js";
import "prebid.js/modules/id5IdSystem.js";
import "prebid.js/modules/identityLinkIdSystem.js";
import "prebid.js/modules/lotamePanoramaIdSystem.js";
import "prebid.js/modules/pairIdSystem.js";
import "prebid.js/modules/sharedIdSystem.js";
import "prebid.js/modules/userId.js";
import "prebid.js/modules/paapi.js";
import "prebid.js/modules/paapiForGpt.js";
import "prebid.js/modules/permutiveRtdProvider.js";
import "prebid.js/modules/pianoDmpAnalyticsAdapter.js";
import "prebid.js/modules/rtdModule.js";
